// extracted by mini-css-extract-plugin
export default {"form":"AddDataSourceForm_form__Mncwk","form-container":"AddDataSourceForm_form-container__dp270"};